import { gql } from "@apollo/client";

export const CategoryFragment = gql`
  fragment CategoryFragment on CategoryTree {
    id
    meta_title
    meta_description
  }
`;

export const ProductsFragment = gql`
  fragment ProductsFragment on Products {
    items {
      __typename
      id
      uid
      name
      unit_text
      enable_site_visit
      enable_appliance_site_visit
      flag_text
      new_price_bundle
      price_range {
        minimum_price {
          regular_price {
            value
            currency
          }
          final_price {
            value
            currency
          }
          discount {
            amount_off
            percent_off
          }
        }
        maximum_price {
          regular_price {
            value
            currency
          }
          final_price {
            value
            currency
          }
          discount {
            amount_off
            percent_off
          }
        }
      }
      sku
      small_image {
        url
      }
      simplebundle
      ... on BundleProduct {
        items {
          option_id
          title
          sku
          type
          required
          position
          options {
            price
            quantity
            product {
              uid
              id
              name
              unit_text
              small_image {
                url
                label
              }
              new_price_bundle
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
              __typename
            }
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          product {
            small_image {
              url
              label
            }
            unit_text
          }
        }
      }
      stock_status
      type_id
      url_key
    }
    page_info {
      total_pages
    }
    total_count
  }
`;
